import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

const { carbon } = colorsPalettes;

const Container = styled.div`
    width: 28px;
    height: 28px;
    background-color: ${carbon[0]};
    border-radius: 4px;
    border: 1px solid ${carbon[50]};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    flex-grow: 0;
`;

const Img = styled.img`
    width: 16px;
    aspect-ratio: 1;
    border-radius: 4px;
`;
export interface IFavicon {
    src: string;
}
export const Favicon: FC<IFavicon> = ({ src }) => {
    return (
        <Container>
            <Img src={src} />
        </Container>
    );
};
